import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const normalizeFavorites = (raw) => {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((item) => item && item.id && item.slug)
    .map((item) => ({
      id: item.id,
      slug: item.slug,
      title: item.title || "",
      thumbnail: item.thumbnail || ""
    }));
};

export const getFavoritesForUser = async (uid) => {
  const ref = doc(db, "users", uid);
  const snap = await getDoc(ref);
  const data = snap.exists() ? snap.data() : {};
  return normalizeFavorites(data.favoriteGames);
};

export const toggleFavoriteForUser = async (uid, game) => {
  const ref = doc(db, "users", uid);
  const snap = await getDoc(ref);
  const data = snap.exists() ? snap.data() : {};
  const favorites = normalizeFavorites(data.favoriteGames);
  const exists = favorites.some((f) => f.id === game.id);

  const updated = exists
    ? favorites.filter((f) => f.id !== game.id)
    : [
        {
          id: game.id,
          slug: game.slug,
          title: game.title || "",
          thumbnail: game.thumbnail || ""
        },
        ...favorites
      ];

  await setDoc(
    ref,
    {
      favoriteGames: updated.slice(0, 50),
      updatedAt: serverTimestamp()
    },
    { merge: true }
  );

  return updated;
};

